import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { formatUKDate } from "@/lib/format";
import { Mail } from "lucide-react";

export default function Emails() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/emails");
        setItems(data);
      } finally { setLoading(false); }
    })();
  }, []);

  return (
    <div className="max-w-4xl mx-auto px-6 py-8" data-testid="emails-page">
      <div className="flex items-center gap-2 flex-wrap">
        <Mail className="h-6 w-6" />
        <h1 className="font-display text-3xl tracking-tight font-bold">Email log</h1>
      </div>
      <div className="mt-2 text-sm text-muted-foreground">
        v1: emails are logged here rather than sent via a real provider. All welcome, reset, invoice, reminder, and receipt emails appear below — great for demos.
      </div>
      <div className="mt-6 space-y-3">
        {loading ? <div className="text-muted-foreground text-sm">Loading…</div> :
         items.length === 0 ? <div className="text-muted-foreground text-sm">No emails yet.</div> :
         items.map((e) => (
          <div key={e.id} className="rounded-xl border border-border bg-card p-5" data-testid={`email-${e.id}`}>
            <div className="flex items-center justify-between flex-wrap gap-2">
              <div className="font-semibold">{e.subject}</div>
              <div className="text-xs text-muted-foreground">{formatUKDate(e.createdAt)}</div>
            </div>
            <div className="text-xs text-muted-foreground">to: {e.to}</div>
            <div className="mt-3 text-sm whitespace-pre-wrap">{e.body}</div>
            {e.meta?.reset_token && <div className="mt-2 text-xs font-mono bg-muted rounded px-2 py-1 inline-block">Reset token: {e.meta.reset_token}</div>}
            {e.meta?.invoice_token && (
              <a href={`/pay/${e.meta.invoice_token}`} className="mt-2 inline-block text-xs text-primary hover:underline">Open payment page →</a>
            )}
          </div>
         ))}
      </div>
    </div>
  );
}
